import { Link } from 'react-router-dom';

const Poster = ({
  caption = '', 
  image = '', 
  link = '', 
  subCaption = ''
}) => (
  <div className="c-poster">
        <div className="c-poster--content">
          {image &&           
            <div className="c-poster--image">
              <img src={image} alt="" />
            </div>
          }
          {caption && 
            <Link to={link} className="c-poster--caption">
              <p className="c-poster--caption__main">{caption}</p>
              <p className="c-poster--caption__sub">{subCaption} &#8250;</p>
            </Link>
          }
        </div>
  </div>
);

export default Poster;
